import styled from 'styled-components';
import { flexAdaptiveSizeItem } from '../../themes/architecture/css-helpers/flex';
import { styledByDevice } from '../../themes/architecture/styled-by-device';



const DefaultBox = styled.h2`
  position: relative;
  min-width: 28rem;
  max-width: 82.5%;
  text-transform: uppercase;
  padding: 1rem 2rem;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  background: ${props => props.theme.components.generalTitle.colors.background};
  border-left: 2px solid ${props => props.theme.colors.brandSecondary};
  color: ${props => props.theme.colors.brandSecondary};
  font-family: ${props => props.theme.font.family.bold};
`;

export const PcBox = styled(DefaultBox)`
    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: .9rem 2rem;
    }
`;

export const MobileBox = styled(DefaultBox)`
    min-width: 65%;
    max-width: 100%;
    padding: .8rem 2rem;
    font-size: 1.2rem;
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        ${flexAdaptiveSizeItem}
        min-width: 0;
    }
`;



export const GeneralTitleDefaultBox = styledByDevice(PcBox, MobileBox);

